import React from 'react';
import styles from "./PhuHuynhNameAndAvavtar.module.css";
import UserAvatar from '../../../components/user-avatar';

interface PhuHuynhProps {
  ho_ten?: string;
  dien_thoai?: string;
  ma_tn?: string;
  avatar?: string;
}

interface PhuHuynhNameAndAvatarProps {
  phuHuynh: PhuHuynhProps;
}

const PhuHuynhNameAndAvavtar: React.FC<PhuHuynhNameAndAvatarProps> = ({ phuHuynh }) => {
  return (
    <div className={styles.container}>
        <div className={styles.avatar}>
        <div
          style={{
            backgroundImage: `url(${'../../../images/hs_avatar.png'})`,
            width: 50,
            height: 50,
            backgroundSize: 'cover',
            borderRadius: '50%',
          }}
        />
      </div>
      <div className={styles.info}>
        <div className={styles.ho_ten}>{phuHuynh.ho_ten}</div>
        <div className={styles.ma_hs}>{phuHuynh.dien_thoai ? phuHuynh.dien_thoai : phuHuynh.dien_thoai}</div>
      </div>
    </div>
  );
};

export default PhuHuynhNameAndAvavtar;
